import { handleActions } from "redux-actions";
import { UTILITIES } from "constants/action-types";
import type { ILookupUser, IBrand, IImpersonation } from "containers/management/management-types";

export interface IState {
    current: ILookupUser;
    brands: IBrand[];
    marketplace_connections: any[];
    retailer_connections: any[];
    requested_connections: any[];
    impersonations: IImpersonation[];
    isLoading: {
        lookup: boolean;
        brands: boolean;
        marketplace_connections: boolean;
        retailer_connections: boolean;
        requested_connections: boolean;
        impersonations: boolean;
    };
    errors: {
        lookup: Error;
        brands: Error;
        marketplace_connections: Error;
        retailer_connections: Error;
        requested_connections: Error;
        impersonations: Error;
    };
}

export const initialState: IState = {
    current: null,
    brands: [],
    marketplace_connections: [],
    retailer_connections: [],
    requested_connections: [],
    impersonations: [],
    isLoading: {
        lookup: false,
        brands: false,
        marketplace_connections: false,
        retailer_connections: false,
        requested_connections: false,
        impersonations: false,
    },
    errors: {
        lookup: null,
        brands: null,
        marketplace_connections: null,
        retailer_connections: null,
        requested_connections: null,
        impersonations: null,
    },
};

export const userLookupReducer = handleActions<IState, any>(
    {
        [UTILITIES.USERS.LOOKUP.CLEAR]: () => {
            return initialState;
        },
        [UTILITIES.USERS.LOOKUP.FETCH.START]: (state: IState) => {
            return {
                ...initialState,
                isLoading: {
                    ...initialState.isLoading,
                    lookup: true,
                },
            };
        },
        [UTILITIES.USERS.LOOKUP.FETCH.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    errors: {
                        ...state.errors,
                        lookup: payload,
                    },
                    isLoading: {
                        ...state.isLoading,
                        lookup: false,
                    },
                };
            }
            return {
                ...state,
                errors: initialState.errors,
                current: payload,
                isLoading: {
                    ...state.isLoading,
                    lookup: false,
                },
                ...(payload?.brands?.length && { brands: payload?.brands }),
                ...(payload?.marketplace_connections?.length && {
                    marketplace_connections: payload?.marketplace_connections,
                }),
                ...(payload?.retailer_connections?.length && {
                    retailer_connections: payload?.retailer_connections,
                }),
                ...(payload?.requested_connections?.length && {
                    requested_connections: payload?.requested_connections,
                }),
                ...(payload?.impersonations?.length && { impersonations: payload?.impersonations }),
            };
        },
        [UTILITIES.USERS.LOOKUP.COLLECTIONS.FETCH.START]: (state: IState, { payload }) => {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [payload.collection]: true,
                },
            };
        },
        [UTILITIES.USERS.LOOKUP.COLLECTIONS.FETCH.SUCCESS]: (state: IState, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    errors: {
                        ...state.errors,
                        [payload.collection]: error,
                    },
                    isLoading: {
                        ...state.isLoading,
                        [payload.collection]: false,
                    },
                };
            }
            return {
                ...state,
                current: {
                    ...state.current,
                    [payload.collection]: state?.current?.[payload?.collection].concat(payload?.response?.collection),
                },
                [payload.collection]: state?.[payload?.collection].concat(payload?.response?.collection),
                isLoading: {
                    ...state.isLoading,
                    [payload.collection]: false,
                },
            };
        },
    },
    initialState
);
